import { render } from "./CompanyDynamics.vue?vue&type=template&id=0a0d0cc8&scoped=true"
import script from "./CompanyDynamics.vue?vue&type=script&lang=js"
export * from "./CompanyDynamics.vue?vue&type=script&lang=js"

import "./CompanyDynamics.vue?vue&type=style&index=0&id=0a0d0cc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0d0cc8"]])

export default __exports__